import React from 'react';
import ActionBarStrip from '../../_partials/ActionBarStrip';
import FavouriteButton from '../../buttons/FavouriteButtonWithPopover';
import CommentButton from '../../buttons/CommentButton';
import ShareButton from '../../buttons/ShareButton';
import AddToGroupButton from '../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../buttons/MoreButton';
import DeleteButton from '../../buttons/DeleteButton';
import EditButton from '../../buttons/EditButton';
import AwardBadgeButton from '../../buttons/AwardBadgeButton';
import { useDeviationAttributes } from '../../../DeviationViews/hooks/useDeviationAttributes';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import OrderCommissionButton from '../../buttons/OrderCommissionButton';
import DownloadButton from '../../buttons/DownloadButton';
import s from './MobileActionBar.scss';
export var MobileActionBar = function (_a) {
    var deviation = _a.deviation, isOwner = _a.isOwner;
    var _b = useDeviationAttributes(deviation, isOwner), hasMoreActions = _b.hasMoreActions, isCommentable = _b.isCommentable, isEditable = _b.isEditable, isFavouritable = _b.isFavouritable, isGroupSubmittable = _b.isGroupSubmittable, isShareable = _b.isShareable, isDeletable = _b.isDeletable, isCoreBadgeAwardable = _b.isCoreBadgeAwardable, isAuthorCommissionable = _b.isAuthorCommissionable;
    var commission = deviation.commission;
    // tiers are technically editable but, for now, the tier edit popup doesn't work on mobile
    var canBeEdited = getDeviationType(deviation) === DeviationTypes.TIER ? false : isEditable;
    return (React.createElement(ActionBarStrip, { className: s['root'] },
        React.createElement("div", { className: s['icons-wrapper'] },
            React.createElement("div", { className: s['left-block'] },
                isFavouritable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(FavouriteButton, { deviation: deviation, actionBarType: "primary" }))),
                isCommentable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(CommentButton, { deviation: deviation, isOwner: isOwner }))),
                !hasMoreActions && isGroupSubmittable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(AddToGroupButton, { deviation: deviation }))),
                isShareable && !hasMoreActions && (React.createElement("span", { className: s['icon'] },
                    React.createElement(ShareButton, { deviation: deviation })))),
            React.createElement("div", { className: s['right-block'] },
                commission && !isOwner && isAuthorCommissionable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(OrderCommissionButton, { deviation: deviation }))),
                isGroupSubmittable && hasMoreActions && (React.createElement("span", { className: s['icon'] },
                    React.createElement(AddToGroupButton, { deviation: deviation }))),
                isCoreBadgeAwardable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(AwardBadgeButton, { deviation: deviation }))),
                hasMoreActions && (React.createElement("span", { className: s['icon'] },
                    React.createElement(MoreButton, { deviation: deviation }))),
                isDeletable && (React.createElement("span", { className: s['icon'] },
                    React.createElement(DeleteButton, { deviation: deviation }))),
                canBeEdited && (React.createElement("span", { className: s['icon'] },
                    React.createElement(EditButton, { deviation: deviation }))))),
        React.createElement("div", { className: s['download-button-row'] },
            React.createElement(DownloadButton, { deviation: deviation }))));
};
MobileActionBar.displayName = 'MobileActionBar';
export default MobileActionBar;
//# sourceMappingURL=MobileActionBar.js.map